import { Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';
@Component({
  selector: 'sbnb-welcomescreen',
  template: `
    <sbnb-apps-detail-page
      vendorCode="welcomescreen"
      name="WelcomeScreen"
      logoTile="/assets/images/apps/welcomescreen/logo.png"
      builtBy="WelcomeScreen Inc"
      [categories]="['Guidebook']"
      [permissions]="[AppPermission.propertyListingRead, AppPermission.reservationRead]"
      email="contact@welcomescreen.com"
      [helpArticles]="[
        { id: '11139304', title: 'Connect Hospitable with WelcomeScreen to Create a Personalized Guide on a TV App' },
      ]">
      <ng-container description>
        <div>
          <p>
            Set up your account on WelcomeScreen using Hospitable integration. Digitize your guest experience,
            seamlessly create personalized welcome messages, share information like WiFi details, emergency contact
            details, nearby places to visit, recommendations etc.
          </p>

          <sbnb-image-carousel
            class="mb-12 block"
            [images]="[
              '/assets/images/apps/welcomescreen/image1.png',
              '/assets/images/apps/welcomescreen/image2.png',
              '/assets/images/apps/welcomescreen/image3.png',
              '/assets/images/apps/welcomescreen/image4.png',
            ]"></sbnb-image-carousel>

          <div style="padding:48.63% 0 0 0;position:relative;">
            <iframe
              src="https://player.vimeo.com/video/1071014370?h=b532f76733&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
              style="position:absolute;top:0;left:0;width:100%;height:100%;"
              title="Screen Recording 2025-03-28 at 8.51.09 PM"></iframe>
          </div>
          <script src="https://player.vimeo.com/api/player.js"></script>
        </div>
      </ng-container>
    </sbnb-apps-detail-page>
  `,
})
export class WelcomescreenComponent {
  public AppPermission = AppPermission;
}
